import splide from '@splidejs/splide'
import { Video } from '@splidejs/splide-extension-video'
import '@splidejs/splide/css'
import '@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css'

export function init() {
  window.splide = splide
  window.SplideVideo = Video
  window.dispatchEvent(
    new CustomEvent('splide-ready', {
      detail: {},
    }),
  )

  if (document.querySelector('.js-image-carousel')) {
    new splide('.js-image-carousel', {
      autoplay: false,
      mediaQuery: 'min',
      perPage: 1,
      focus: 'center',
      pagination: false,
      type: 'loop',
      updateOnMove: true,
      isNavigation: true,
      lazyload: 'nearby',
      classes: {
        arrow: 'splide__arrow',
      },
      breakpoints: {
        640: {
          perPage: 2,
        },
        768: {
          perPage: 3,
        },
      },
    }).mount()
  }
}
